export { ActivitiesComponent } from './activities.component';

export {ActivitiesMessageComponent} from './activities-message'
export {ActivitiesTaskComponent} from './activities-task'
export {ActivitiesNotificationComponent} from './activities-notification'



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/header/activities/index.ts